/** Logical browser-session ownership. Token rotation does not replace a session. */
let generation = 0;
const listeners = new Set<() => void>();

export const getSessionOwner = (): number => generation;
export const ownsSession = (owner: number): boolean => owner === generation;

export class ObsoleteSessionError extends Error {
  constructor() {
    super('The initiating session is no longer current');
    this.name = 'ObsoleteSessionError';
  }
}

export const assertSessionOwner = (owner: number): void => {
  if (!ownsSession(owner)) throw new ObsoleteSessionError();
};

export const replaceSession = (): number => {
  generation += 1;
  for (const listener of listeners) listener();
  return generation;
};

export const onSessionReplacement = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
